import React from 'react'
import { Card, Row } from 'react-bootstrap'
import { AccordionSection } from '../../accordion'
import { Tabs } from '@mmsg/louie'
import { formatCurrency } from '../../../helpers'
import globals from 'application/constants/globals'
import ColItem from './colItem'
import * as S from './estimateDetailElements'

interface IInputProps {
  spFeePerPay: { incGST: number; exGST: number }
  nlFeePerPay: { incGST: number; exGST: number }
  spFeePerAnnum: { incGST: number; exGST: number }
  nlFeePerAnnum: { incGST: number; exGST: number }
  isExGST: boolean
  expandAccordion: boolean
  payFrequency: string
}

const FeesAndChargesSection = (props: IInputProps) => {
  let totalFees = props.isExGST
    ? props.spFeePerPay.exGST + props.nlFeePerPay.exGST
    : props.spFeePerPay.incGST + props.nlFeePerPay.incGST

  interface IFeesTableProps {
    id: string
    nlFee: number
    spFee: number
    isExGST: boolean
  }

  const FeesTable = (props: IFeesTableProps) => {
    return (
      <Row>
        <ColItem
          icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
          id={`${props.id}-nlFee`}
          title={globals.brand + ' novated leasing'}
          value={props.nlFee}
          tooltip={{
            text: 'What we charge for taking care of your lease & removing hassle for you at every turn. From negotiating with dealerships to your admin throughout your lease.',
          }}
          isExGST={props.isExGST}
        />

        <ColItem
          icon={globals.isBrandMX ? 'LeaseFees' : 'IconDollar3'}
          id={`${props.id}-spFee`}
          title="Salary packaging"
          value={props.spFee}
          tooltip={{
            text: 'An administration fee agreed upon with your employer, in exchange for managing your salary packaging account.',
          }}
          isExGST={props.isExGST}
        />
      </Row>
    )
  }

  return totalFees > 0 ? (
    <div>
      <Card className="mb-13rem print-page-break-before card-shadow">
        <Card.Header className="border-bottom-0 d-flex justify-content-between">
          <S.CardHeader className="text-header">
            Novated lease fees and charges
          </S.CardHeader>
          <S.CardHeaderValue id="runningsection.feesandcharges">
            {formatCurrency(totalFees)}
          </S.CardHeaderValue>
        </Card.Header>
        <Card.Body>
          <AccordionSection
            readerText="Novated lease fees and charges"
            expandAccordion={props.expandAccordion}
            title="In exchange for the benefits of a novated lease, there are a few fees and charges along the way. These are covered by your pre-tax income."
            id="runningsection.feesaccordion1"
            defaultActive={false}
          >
            <Tabs
              id="runningsection.leasefeestabletab"
              data={[
                {
                  title: props.payFrequency,
                  content: () => (
                    <FeesTable
                      nlFee={
                        props.isExGST
                          ? props.nlFeePerPay.exGST
                          : props.nlFeePerPay.incGST
                      }
                      spFee={
                        props.isExGST
                          ? props.spFeePerPay.exGST
                          : props.spFeePerPay.incGST
                      }
                      id={`lease-fees-perPay`}
                      isExGST={props.isExGST}
                    />
                  ),
                },
                {
                  title: 'Annually',
                  content: () => (
                    <FeesTable
                      nlFee={
                        props.isExGST
                          ? props.nlFeePerAnnum.exGST
                          : props.nlFeePerAnnum.incGST
                      }
                      spFee={
                        props.isExGST
                          ? props.spFeePerAnnum.exGST
                          : props.spFeePerAnnum.incGST
                      }
                      id={`lease-fees-Annually`}
                      isExGST={props.isExGST}
                    />
                  ),
                },
              ]}
              activeIndex={0}
              equalWidth
            />
          </AccordionSection>
        </Card.Body>
      </Card>
    </div>
  ) : (
    <></>
  )
}

export default FeesAndChargesSection
